import { TestId } from "#/test-ids";

import "../teasers.js";

window.Sparkle ??= {};
window.Sparkle.MobileCTA ??= {};

Sparkle.MobileCTA.TeaserBar = class TeaserBar extends Sparkle.MobileCTA.Teasers {};
Sparkle.MobileCTA.TeaserBar.prototype.className = "mobile-cta-sticky-teaser-wrapper";
Sparkle.MobileCTA.TeaserBar.prototype.testId = TestId.cta.mobileTeaserBar;
Sparkle.MobileCTA.TeaserBar.prototype.teaserTestId = TestId.cta.mobileTeaser;
